// extracted by mini-css-extract-plugin
export var bodySections = "_d8-8";
export var gray = "_d8-7";
export var green = "_d8-4";
export var iconContainer = "_d8-9";
export var iconWidgetContainer = "_d8-1";
export var phoneIcon = "_d8-2";
export var red = "_d8-5";
export var statusDot = "_d8-3";
export var widgetContainer = "_d8-0";
export var yellow = "_d8-6";